export default "__VITE_ASSET__DNxAQ7qy__"